export const SYMBOL_TOGGLE_STROKE = { normal: 1.7, pressed: 2.3 } as const;
